import { Container } from './styles'
import LoaderQuestion from '../LoaderQuestion'
import { IQuestion } from '../SearchQuestionsContent/types'
import Question from 'components/Question'
import { setState } from 'types/setState'

interface IProps {
  data: IQuestion[]
  fontSize: number
  page: number
  itemsPerPage: number
  isLoading?: boolean
  onAnswer?(): void
  id?: string

  isMobile?: boolean

  dataKey?: string
  setHideTheme?: setState<boolean>
  setHideDetails?: setState<boolean>
  hideTheme?: boolean
  hideDetails?: boolean
  unanswered?(): void
  setTracking: setState
}

const QuestionsList = (props: IProps) => {
  const renderQuestion = (question: IQuestion, index: number) => (
    <Question
      id={props.id}
      data={question}
      key={question._id}
      position={!props.isMobile ? (props.page - 1) * props.itemsPerPage + index + 1 : index + 1}
      hideTheme={props.hideTheme}
      hideDetails={props.hideDetails}
      onHideTheme={(val) => props.setHideTheme(val)}
      onHideDetails={(val) => props.setHideDetails(val)}
      fontSize={props.fontSize}
      onAnswer={props.onAnswer}
      dataKey={props.dataKey}
      unanswered={props.unanswered}
      setTracking={props.setTracking}
    />
  )
  if (!props.isMobile && props.isLoading)
    return (
      <Container>
        <LoaderQuestion isMobile={props.isMobile} />
      </Container>
    )

  return (
    <Container>
      {props.data.map(renderQuestion)}
      {props.isMobile && props.isLoading && <LoaderQuestion isMobile={props.isMobile} />}
    </Container>
  )
}

export default QuestionsList
